<nz-layout>
  <nz-content>
    <app-reusable-table
      class="care-plan-table"
      title="Active Care Plans"
      [columns]="[
        'Title',
        'Status',
        'Intent',
        'Category',
        'Period Start',
        'Period End',
        'Description',
      ]"
      [rowFields]="[
        'title',
        'statusDisplay',
        'intentDisplay',
        'categoryDisplay',
        'periodStartDatetime',
        'periodEndDatetime',
        'description',
      ]"
      [data]="activeCarePlans"
      [deleteFun]="deleteFun"
      [isLoading]="isLoading"
      [openModalFun]="openModalFun"
      [customActions]="customActions"
      [isPreview]="false"
      [addPermissions]="['a-cp']"
      [stopPermissions]="['s-cp']"
      [showAddButtonOverride]="true"
      [addButtonHandler]="openAddCarePlan"
      [stopFun]="stopFun"
      [isExistingDraftFun]="isExistingRevision"
      [stopTooltip]="'Stop care plan'"
      [revertStopTooltip]="'Resume care plan'"
    />

    <app-reusable-table
      class="care-plan-table"
      title="Past Care Plans"
      [columns]="[
        'Title',
        'Status',
        'Intent',
        'Category',
        'Period Start',
        'Period End',
        'Description',
      ]"
      [rowFields]="[
        'title',
        'statusDisplay',
        'intentDisplay',
        'categoryDisplay',
        'periodStartDatetime',
        'periodEndDatetime',
        'description',
      ]"
      [data]="pastCarePlans"
      [deleteFun]="deleteFun"
      [isLoading]="isLoading"
      [openModalFun]="openModalFun"
      [customActions]="customActions"
      [isPreview]="false"
      [addPermissions]="['a-cp']"
      [stopPermissions]="['s-cp']"
      [revertStopFun]="revertStopFun"
      [isStopped]="true"
      [stopTooltip]="'Stop care plan'"
      [revertStopTooltip]="'Resume care plan'"
    />
  </nz-content>
</nz-layout>

<nz-modal
  [(nzVisible)]="isDeleteModalVisible"
  [nzTitle]="'Delete Care Plan' | translate"
  [nzFooter]="null"
  nzWidth="560px"
  (nzOnCancel)="closeDeleteModal()"
>
  <ng-container *nzModalContent>
    <p class="delete-care-plan-lead">
      {{ "Choose how to delete this care plan." | translate }}
    </p>
    <p class="delete-care-plan-note">
      {{
        "Keep records detaches linked draft attachments from the care plan and keeps the files stored. Delete all removes linked draft attachments, their files, and other generated draft records."
          | translate
      }}
    </p>

    <div class="delete-care-plan-actions">
      <button
        nz-button
        nzType="default"
        class="cancel-delete-btn"
        type="button"
        (click)="closeDeleteModal()"
      >
        {{ "Cancel" | translate }}
      </button>
      <button
        nz-button
        nzType="default"
        class="keep-records-btn"
        type="button"
        (click)="confirmDeleteCarePlan(false)"
      >
        {{ "Keep records, delete care plan" | translate }}
      </button>
      <button
        nz-button
        nzType="primary"
        nzDanger
        class="delete-all-btn"
        type="button"
        (click)="confirmDeleteCarePlan(true)"
      >
        {{
          "Delete all generated/draft linked records and attachments"
            | translate
        }}
      </button>
    </div>
  </ng-container>
</nz-modal>
